import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64bedb34"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["accept"]

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FileInput',
  props: {
    accept: { default: 'image/*' }
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

const inputRef = ref<HTMLInputElement>()

const handleClick = () => {
  if (!inputRef.value) return
  inputRef.value.value = ''
  inputRef.value.click()
}
const handleChange = (e: Event) => {
  const files = (e.target as HTMLInputElement).files
  if (files) emit('change', files)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "file-input",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (handleClick()))
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("input", {
      class: "input",
      type: "file",
      name: "upload",
      ref_key: "inputRef",
      ref: inputRef,
      accept: _ctx.accept,
      onChange: _cache[0] || (_cache[0] = $event => handleChange($event))
    }, null, 40, _hoisted_1)
  ]))
}
}

})